export const capitalizeI = (sentence) => {
    return sentence.replace(/\b(i)\b/gi, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};
